import { InnerContainer, MainContainer } from './Style';

export const Layout = (WrappedComponent: any) => {
    return (props: any) => {
        return (
            <MainContainer>
                <InnerContainer>
                    <WrappedComponent {...props} />
                </InnerContainer>
            </MainContainer>
        );
    };
};
